import { useEffect, useRef, useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Experience } from "@/components/landing/Experience";
import { Services } from "@/components/landing/Services";
import { Manifesto } from "@/components/landing/Manifesto";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials } from "@/components/landing/Testimonials";
import { OrderForm } from "@/components/landing/OrderForm";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppButton } from "@/components/landing/WhatsAppButton";
import ThankYou from "@/components/landing/ThankYou";

function Landing() {
  const lenisRef = useRef(null);
  const [selectedPlan, setSelectedPlan] = useState("x3");

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((href) => {
    const target = href === "#top" ? 0 : href;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: href === "#top" ? 0 : -70 });
    } else {
      const el = document.querySelector(href);
      el?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const selectOffer = useCallback(
    (offer) => {
      setSelectedPlan(offer.id);
      scrollTo("#pedido");
    },
    [scrollTo]
  );

  return (
    <div className="App grain bg-bg text-ink overflow-x-hidden">
      <Toaster position="top-center" richColors />
      <Navbar onScrollTo={scrollTo} />
      <main>
        <Hero onScrollTo={scrollTo} />
        <EditorialMarquee />
        <Experience />
        <Services />
        <Manifesto />
        <Pricing onSelect={selectOffer} />
        <Testimonials />
        <OrderForm selectedPlan={selectedPlan} />
      </main>
      <Footer onScrollTo={scrollTo} />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/gracias" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
